import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private toastSubject: BehaviorSubject<ToastMessage | null> = new BehaviorSubject<ToastMessage | null>(null);
  toast$: Observable<ToastMessage | null> = this.toastSubject.asObservable();

  showToast(type: ToastType, message: string): void {
    this.toastSubject.next({ type, message });
  }

  showSuccess(message: string): void {
    this.showToast('success', message);
  }

  showError(message: string): void {
    this.showToast('error', message);
  }

  showWarning(message: string): void {
    this.showToast('warning', message);
  }

  showInfo(message: string): void {
    this.showToast('info', message);
  }

  clearToast(): void {
    this.toastSubject.next(null);
  }
}

export interface ToastMessage {
  type: ToastType;
  message: string;
}

export type ToastType = 'success' | 'error' | 'warning' | 'info';
